import SelectionExtension from './SelectionExtension';

export default SelectionExtension;
